import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    col1: {
        fill: '#FF6600',
        fillRule: 'nonzero',
    },
}

const areasSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 732 732" width={width} height={height}>
        <g>
            <polygon style={{ fill: color }} points="609,684 350,684 350,484 609,484 "/>
            <path style={{ fill: color }}
                  d="M75 266l0 433 552 0 0 -433 -552 0zm259 400l0 0 -227 0 0 -167 227 0 0 167zm0 -200l0 0 -227 0 0 -166 227 0 0 166zm260 200l0 0 -227 0 0 -167 227 0 0 167zm0 -200l0 0 -227 0 0 -166 227 0 0 166z"/>
        </g>
        <g>
            <polygon style={styles.col1} points="608,684 348,684 348,484 608,484 "/>
            <g>
                <path style={{ fill: color }}
                      d="M683 300c0,0 0,0 0,0l-667 0c-7,0 -13,-5 -15,-12 -2,-6 0,-14 5,-18l333 -266c6,-5 15,-5 20,0l332 264c5,3 8,9 8,15 0,9 -7,17 -16,17zm-620 -34l0 0 572 0 -286 -228 -286 228z"/>
            </g>
            <path style={{ fill: color }}
                  d="M74 266l0 433 551 0 0 -433 -551 0zm259 400l0 0 -227 0 0 -167 227 0 0 167zm0 -200l0 0 -227 0 0 -166 227 0 0 166zm260 200l0 0 -227 0 0 -167 227 0 0 167zm0 -200l0 0 -227 0 0 -166 227 0 0 166z"/>
        </g>
    </svg>
)

areasSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

areasSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default areasSVG
